// eslint-disable-next-line @typescript-eslint/no-unused-vars -- required by the classic JSX runtime (tsconfig "jsx": "react")
import React from 'react';

import SettingsToggle from '../../../components/SettingsToggle';
import SaveIndicator, { type SaveStatus } from './SaveIndicator';
import type { UserRole } from '@prerender/prerender-shared/FE';

const STATUS_CAPTION = 'Status';
const STATUS_LABEL = { active: 'Active', inactive: 'Inactive' } as const;

type SettingsToggleRowProps = {
  checked: boolean;
  status: SaveStatus;
  onRetry: () => void;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  disabledFor?: UserRole | readonly UserRole[];
  ariaLabel?: string;
};

// The shared "Status" row for every General-tab toggle: a "Status" caption, the toggle, an
// Active/Inactive label that tracks the toggle's own checked state, and the save indicator.
function SettingsToggleRow({ checked, status, onRetry, onChange, disabled, disabledFor, ariaLabel }: SettingsToggleRowProps) {
  return (
    <div className="row">
      <div className="col">
        <label className="form-check-label d-block">{STATUS_CAPTION}</label>
        <span>
          <SettingsToggle
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            disabledFor={disabledFor}
            aria-label={ariaLabel}
          />{' '}
          {checked ? STATUS_LABEL.active : STATUS_LABEL.inactive}
        </span>
      </div>
      <SaveIndicator status={status} onRetry={onRetry} />
    </div>
  );
}

export default SettingsToggleRow;
